import React from 'react';
import { useSelector } from 'react-redux';

import LogoImage from 'src/assets/images/Logo.svg';
import LogoImageWhite from 'src/assets/images/LogoWhite.svg';

import { StyledLogoLink, StyledLogoWrap } from '../styled';

type LogoProps = {
  /**
   * Navigation target when the logo is clicked.
   * Defaults to home (`/`). Pass `null` to render without a link.
   */
  to?: string | null;
};

const Logo: React.FC<LogoProps> = ({ to }) => {
  const { isDark } = useSelector(({ isDark }) => isDark);
  const href = to === undefined ? '/' : to;

  const image = (
    <StyledLogoWrap className="logo_wrap">
      <img className="logo_image" src={isDark ? LogoImageWhite : LogoImage} alt="BxLend" />
    </StyledLogoWrap>
  );

  if (href) {
    return (
      <StyledLogoLink to={href} aria-label="Go to home">
        {image}
      </StyledLogoLink>
    );
  }

  return image;
};

export default Logo;
